import * as types from './constants';

export const setIsLoading = isLoading => ({
  type: types.SET_IS_LOADING,
  isLoading
});

export const setSchedulingConfiguration = data => ({
  type: types.SET_SCHEDULING_CONFIGURATION,
  data
});

export const clearSchedulingConfiguration = () => ({
  type: types.CLEAR_SCHEDULING_CONFIGURATION
});